import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { SelectClassificationState, singleSelectInitialState } from '../../components/SelectClassification';
import { ActivityTypeEnum } from '../../api/@types';

export interface DayBadge {
  id: string;
  label: string;
  dayOfWeek: string;
}

export interface HistoricState {
  classification: SelectClassificationState;
  activityType: string;
  dates: DayBadge[];
  visualization: 'questions' | 'activities';
}

export interface HistoricStatePayload {
  name: keyof HistoricState;
  value: string;
}

export const historicInitialState: HistoricState = {
  classification: singleSelectInitialState,
  activityType: '',
  dates: [],
  visualization: 'activities',
};

const { reducer, actions } = createSlice({
  name: 'historic-page',
  initialState: historicInitialState,
  reducers: {
    setClassification: (state, action: PayloadAction<SelectClassificationState>): HistoricState => {
      const newClassification = action.payload;

      return {
        ...state,
        classification: newClassification,
      };
    },
    setActivityType: (state, action: PayloadAction<string>): HistoricState => {
      const value = action.payload;

      if (value === ActivityTypeEnum.Exam || value === ActivityTypeEnum.MockExam) {
        return {
          ...state,
          classification: singleSelectInitialState,
          activityType: value,
        };
      }

      return {
        ...state,
        activityType: value,
      };
    },
    setDate: (state, action: PayloadAction<DayBadge>): HistoricState => {
      const value = action.payload;

      const find = state.dates.find((i) => i.id === value.id);
      if (find) {
        return {
          ...state,
          dates: state.dates.filter((i) => i.id !== value.id),
        };
      }
      return {
        ...state,
        dates: [...state.dates, value],
      };
    },
    setFinalDate: (state, action: PayloadAction<DayBadge[]>): HistoricState => {
      const days = action.payload;

      const arrDays = days.map((i) => i.id);

      let check = false;
      state.dates.forEach((i) => {
        if (arrDays.includes(i.id)) {
          check = true;
        }
      });

      if (!check) {
        return {
          ...state,
          dates: [...state.dates, days[days.length - 1]],
        };
      }

      return state;
    },
    setField: (state, action: PayloadAction<HistoricStatePayload>): HistoricState => {
      const { name, value } = action.payload;

      return {
        ...state,
        [name]: value,
      };
    },
    reset: (): HistoricState => ({
      ...historicInitialState,
    }),
  },
});

const persistentReducer = persistReducer({
  key: 'historic-page',
  storage,
}, reducer);

export { actions };
export default persistentReducer;
